export default {
	set_rights: function(newData) {
		window.localStorage.setItem("salesianer-market-rights", newData);
	},
	clear_rights: function() {
		window.localStorage.setItem("salesianer-market-rights", "");
	},
	get_json_object: function() {
		var json = window.localStorage.getItem("salesianer-market-rights");
		if (json == null || json == "") json = "{}";
		return JSON.parse(json);
	},
	is_crc_valid: function() {
		var jsonRights = this.get_json_object();

		if (jsonRights != null && jsonRights.UserType != null) {
			var test_crc = 0;
			for (var i = 0; i < jsonRights.UserType.length; i++) {
				var chr = jsonRights.UserType.charAt(i).charCodeAt(0);
				test_crc += chr;
			}
			test_crc = test_crc * 23 - 1;
			var crc = jsonRights.Crc ? jsonRights.Crc : -1;
			return crc == test_crc;
		}
		return false;
	},
	is_user_type: function(name) {
		var jsonRights = this.get_json_object();
		if (this.is_crc_valid()) {
			if (jsonRights != null && jsonRights.UserType != null) {
				var user_type = jsonRights.UserType;
				return user_type == name;
			}
		}
		return false;
	},
	is_power_user: function() {
		return this.is_user_type("power_user");
	},
	is_market_user: function() {
		return this.is_user_type("market_user");
	},
	is_guest_user: function() {
		return this.is_user_type("guest");
	},
	is_not_guest: function() {
		return !this.is_guest_user();
	},
	is_admin: function() {
		return this.is_user_type("system_admin");
	},
	is_admin_or_power_user: function() {
		return this.is_any_of_this_types(["system_admin", "power_user"]);
	},
	is_any_of_this_types: function(types) {
		var ret = false;
		types.forEach(user_type => {
			if (this.is_user_type(user_type)) ret = true;
		});
		return ret;
	}
};
